import React from "react";
import {
  isCompleteOtpCode,
  OTP_CODE_LENGTH,
  sanitizeOtpCodeInput,
} from "./otpCodeHelpers";

/**
 * Presentation-only six-digit OTP field.
 * Leading zeros preserved; type=text + numeric inputMode; no type=number.
 */
function OtpCodeInput({
  id,
  name,
  value,
  onChange,
  disabled = false,
  className = "",
  placeholder = "••••••",
  "aria-invalid": ariaInvalid,
  "aria-describedby": ariaDescribedBy,
  "data-testid": dataTestId,
  inputRef,
}) {
  const handleChange = (event) => {
    const next = sanitizeOtpCodeInput(event.target.value);
    if (typeof onChange === "function") {
      onChange(next);
    }
  };

  return (
    <input
      id={id}
      name={name}
      ref={inputRef}
      type="text"
      inputMode="numeric"
      autoComplete="one-time-code"
      maxLength={OTP_CODE_LENGTH}
      className={className}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
      data-testid={dataTestId}
    />
  );
}

export { isCompleteOtpCode, OTP_CODE_LENGTH, sanitizeOtpCodeInput };
export default OtpCodeInput;
